import store from "@/store";
import axios from "axios";
import { Message } from "element-ui";
import util from "@/libs/util";
import cryptoJS from "@/libs/util.cryptoJS.js";
import XEUtils from "xe-utils";

// 创建一个错误
function errorCreate(msg) {
  const error = new Error(msg);
  errorLog(error);
  throw error;
}

// 记录和显示错误
function errorLog(error) {
  // 添加到日志
  store.dispatch("d2admin/log/push", {
    message: "数据请求异常",
    type: "danger",
    meta: {
      error
    }
  });
  // 打印到控制台
  if (process.env.NODE_ENV === "development") {
    util.log.danger(">>>>>> Error >>>>>>");
    console.log(error);
  }
  // 显示提示
  Message({
    message: error.message,
    type: "error",
    duration: 5 * 1000
  });
}
// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 30000 // 请求超时时间
});
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    if (config.juge && config.juge == 1) {
      config.baseURL = config.baseURL.replace(/api/, "aip");
      console.log("config.baseURL", config.baseURL);
      console.log("config.url", config.url);
    }

    //普通上传,就进行内容加密
    if (config.data) {
      if (Object.prototype.toString.call(config.data) != "[object FormData]") {
        config.data = cryptoJS.aesEncryptObj2Obj(config.data);
      } else {
        //FormData是上传附件,需要改头部
        config.headers["Content-Type"] = "multipart/form-data";
      }
    }

    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改,如果没有,就是undefined
    const token = util.cookies.get("token");
    const name = util.cookies.get("name");
    const workId = util.cookies.get("workId");
    const officeId = util.cookies.get("officeId");
    const workName = util.cookies.get("workName");
    const officeName = util.cookies.get("officeName");
    const plantName = util.cookies.get("plantName");
    const WeUserID = util.cookies.get("WeUserID");
    config.headers["X-Token"] = token;
    config.headers["UserName"] = encodeURI(name); //header不能传递中文,要先转码
    config.headers["workId"] = encodeURI(workId); //header不能传递中文,要先转码
    config.headers["officeId"] = encodeURI(officeId); //header不能传递中文,要先转码
    config.headers["workName"] = encodeURI(workName); //header不能传递中文,要先转码
    config.headers["officeName"] = encodeURI(officeName); //header不能传递中文,要先转码

    config.headers["plantName"] = encodeURI(plantName); //header不能传递中文,要先转码
    config.headers["WeUserID"] = encodeURI(WeUserID); //header不能传递中文,要先转码

    let dn = new Date();
    let utcTimeStamp = dn.getTime() + dn.getTimezoneOffset() * 60000;
    config.headers["ReqToken"] = cryptoJS.aesEncryptObj2Obj(utcTimeStamp).word; //传入毫秒的时间戳，无视时区
    return config;
  },
  error => {
    // 发送失败
    console.log(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data;
    // 这个状态码是和后端约定的
    const code = dataAxios.code;
    //根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
      return dataAxios;
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断

      let res;
      switch (code) {
        case 0:
          // code === 0 代表没有错误
          res = cryptoJS.aesDecryptText(dataAxios.data); //解密
          return res;
          break;

        case 1:
          // 其它和后台约定的 code
          res = cryptoJS.aesDecryptText(dataAxios.data); //解密
          errorCreate(` ${dataAxios.msg}: ${res}`);
          break;
        case 99:
          //99是登录状态超时或未登陆
          res = cryptoJS.aesDecryptText(dataAxios.data); //解密
          // Message.error(` ${dataAxios.msg}: ${res}`)
          store.dispatch("d2admin/account/logout");
          break;
        default:
          // 不是正确的 code
          errorCreate(`${dataAxios.msg}: ${response.config.url}`);
          break;
      }
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          error.message = "未授权，请登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = `暂无信息`;

          // error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器内部错误";
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          break;
      }
    }
    errorLog(error);
    return Promise.reject(error);
  }
);

export default service;
